export const PlayerConstants = {
    PROCESS_PATH: "Stage_DRS",
    PARALLEL_PICK_PROCESS_PATH: "Parallel_Pick",
    VERSION: "V1.0.156.0"
};

export const HelpTypes = {
    DEFAULT: 'Default'
};
